/**
 * Routes du parcours de mise en route.
 *
 * L'identifiant de l'élevage est porté par l'URL dès l'étape 2 : le bouton Précédent du
 * navigateur reste cohérent et un rafraîchissement ne perd rien — contrairement au tunnel
 * d'inscription, qui passe son état par `navigate(state)`.
 */
export const SETUP_ROOT = "/breeder/mise-en-route";

/** Mot d'accueil : la racine du parcours, là où l'espace éleveur envoie un compte vierge. */
export const setupWelcomePath = () => SETUP_ROOT;
export const setupBreedingPath = () => `${SETUP_ROOT}/elevage`;
export const setupBuildingsPath = (breedingId: number | string) =>
  `${SETUP_ROOT}/${breedingId}/batiments`;
export const setupDevicesPath = (breedingId: number | string) =>
  `${SETUP_ROOT}/${breedingId}/produits`;
export const setupSummaryPath = (breedingId: number | string) =>
  `${SETUP_ROOT}/${breedingId}/recapitulatif`;

export type SetupStep = 1 | 2 | 3 | 4;
